/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */



//Singleton?

export class SnapGlobeWebSocket {
    #websocket;
    #url;
    constructor(url) {
        this.#url = url;
    }

    onMessageListener;
    open() {
        this.#websocket = new WebSocket(this.#url);
        this.#websocket.binaryType = "arraybuffer";
        this.#websocket.addEventListener("message", this.#onMessage);
        this.#websocket.addEventListener("error", this.#onError);
    }

    close() {
        this.#websocket.close();
    }

    isOpen() {
        
        return this.#websocket && this.#websocket.readyState === 1;
    }
    /*
     * Richieste: protocollo semplice con messaggi JSON
     * {
     *  "_id":333,
     *  
     * }
     */
    send(data, callback) {
        if (this.#websocket.readyState === 1) {
            this.#websocket.send(data);
        }
    }

    #onOpen(event) {

    }

    #onClose(event) {

    }

    #onError(event) {
        let stop = 0;
    }

//Protocollo semplice con messaggi JSON
    #onMessage = (event) => {
        if (event.data instanceof ArrayBuffer) {
            if (event.data && event.data[0] === 'ping') {
                this.send(event.data)
            } else {
                if (this.onMessageListener) {
                    this.onMessageListener(event.data);
                }
            }
        }
    }

}